export default __webpack_public_path__ + "static/media/IBimagefootplantfromabove2.ca5940c3.png";